// import firebase from 'firebase/app';
// Add the Firebase products that you want to use
// import "firebase/auth";
// import "firebase/firestore";
import AuthApi from "@/services/auth-api";

// import router from "./router";


// import Swal from "sweetalert2";
// import store from '@/state/store'
// import router from './router/index'

class FirebaseAuthBackend {
    constructor() {
        // Initialize Firebase
        //firebase.initializeApp();
        /*firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                sessionStorage.setItem("authUser", JSON.stringify(user));
            } else {
                sessionStorage.removeItem('authUser');
            }
        });*/
    }

    /**
     * Registers the user with given details
     */
    registerUser = (email, password, name, supplierCode ) => {
        return new Promise((resolve, reject) => {

            AuthApi.register(email, password, name, supplierCode)
            .then(response => {
                sessionStorage.setItem("authUser", JSON.stringify(response.username));
                sessionStorage.setItem("userFullName", response.fullName);
                sessionStorage.setItem("token", response.token);
                sessionStorage.setItem("rtoken", response.refreshToken);
                resolve(response.username);
            }, (error) => {
                reject(this._handleError(error));
            });


            /*firebase.auth().createUserWithEmailAndPassword(email, password).then((user) => {
                // eslint-disable-next-line no-redeclare
                var user = firebase.auth().currentUser;
                resolve(user);
            }, (error) => {
                reject(this._handleError(error));
            });*/


        });
    }

    /**
     * Login user with given details
     */
    loginUser = (email, password) => {
        return new Promise((resolve, reject) => {
            AuthApi.signIn(email, password)
            .then(response => {
                sessionStorage.setItem("authUser", JSON.stringify(response.username));
                sessionStorage.setItem("userFullName", response.fullName);
                sessionStorage.setItem("token", response.token);
                sessionStorage.setItem("rtoken", response.refreshToken);
                sessionStorage.setItem("userr", response.role);

                resolve(response);
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * forget Password user with given details
     */
    /*forgetPassword = (email) => {
        return new Promise((resolve, reject) => {
            firebase.auth().sendPasswordResetEmail(email, { url: window.location.protocol + "//" + window.location.host + "/login" }).then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    }*/

    /**
     * Logout the user
     */
    logout = () => {
        return new Promise((resolve, reject) => {
            AuthApi.logout()
            .then(() => {
                sessionStorage.removeItem('authUser');
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('rtoken');
                sessionStorage.removeItem('userFullName');
                sessionStorage.removeItem('userr');
                resolve(true);
            }, (error) => {
                reject(this._handleError(error));
            });
        });

        /*return new Promise((resolve, reject) => {
            AuthApi.
            firebase.auth().signOut().then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })

        });*/
    }

    setLoggeedInUser = (user) => {
        sessionStorage.setItem("authUser", JSON.stringify(user));
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser = () => {
        if (!sessionStorage.getItem('authUser'))
            return null;
        return JSON.parse(sessionStorage.getItem('authUser'));
    }

    /**
     * Handle the error
     * @param {*} error 
     */
    _handleError(error) {
        //TODO to be fixed later
        // var errorMessage = error.message;
        // return errorMessage;
        console.log(error)
        return  ("Login ou mot de passe erroné")
    }
}


let _fireBaseBackend = null;

const initFirebaseBackend = () => {
    if (!_fireBaseBackend) {
        _fireBaseBackend = new FirebaseAuthBackend();
    }
    return _fireBaseBackend;
}

const getFirebaseBackend = () => {
    return _fireBaseBackend;
}

const refreshToken = (store) => {
    if (store.state.auth.isRefreshing) {
        return store.state.auth.refreshingCall;
    }
    // store.commit('auth/setRefreshingState', true);
    const refreshingCall = AuthApi.refresh(sessionStorage.getItem('rtoken')).then((response) => {
        
        sessionStorage.setItem("token", response.token);

        // store.commit('auth/setToken', response.token)
        // store.commit('auth/setRefreshingState', false);
        // store.commit('auth/setRefreshingCall', undefined);
        return Promise.resolve(true);
    // }, (error) => {
    //     return Promise.reject(false);
        }, () => {
        return Promise.reject(false);
                
            }
    
    
    
    );
    // store.commit('auth/setRefreshingCall', refreshingCall);
    return refreshingCall;
}


export { initFirebaseBackend, getFirebaseBackend, refreshToken };
